import { useRouter } from "next/navigation"

import { useCustomSearchParams } from "."

type PushNavigateOptions = {
  scroll?: boolean
  noParams?: boolean
  cleanupParams?: string[]
}

const useNavigation = () => {
  const router = useRouter()
  const [searchParams] = useCustomSearchParams()

  const mergeSearchParams = (params: string, cleanupParams?: string[]) => {
    const newParams = new URLSearchParams(params)
    for (const [key, value] of searchParams) {
      if (!newParams.has(key)) {
        newParams.set(key, value)
      }
    }
    cleanupParams?.forEach((p) => newParams.delete(p))

    return newParams.toString()
  }

  const computeNewPath = (href: string, options: PushNavigateOptions) => {
    const [path, search = ""] = href?.split("?") || ["", ""]
    if (options.noParams) return path
    return `${path}?${mergeSearchParams(search, options.cleanupParams)}`
  }

  const push = (
    href: string,
    options: PushNavigateOptions = { scroll: false },
  ) => {
    router.push(computeNewPath(href, options), {
      scroll: options?.scroll,
    })
  }

  const replace = (
    href: string,
    options: PushNavigateOptions = { scroll: false },
  ) =>
    router.push(computeNewPath(href, options), {
      scroll: options?.scroll,
    })

  return {
    ...router,
    push,
    replace,
  }
}

export { useNavigation }
export type { PushNavigateOptions }
